import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import { CollabSpaceViewState } from './schema';

interface CollabSpaceStore {
    entries: ObservableMap<string, CollabSpaceViewState>;
}

const collabSpaceStoreData: CollabSpaceStore = {
    entries: new ObservableMap(),
};

export const getCollabSpaceStore = createStore<CollabSpaceStore>(
    'CollabSpaceStore',
    collabSpaceStoreData
);
